<ng-container *ngIf="preauthModel" [formGroupName]="controlKey">
  <div class="card">
    <h5 class="card-header text-center"
      [ngClass]="(sallabel && sallabel === 'Pensioner') ? 'pension-card' : (sallabel && sallabel === 'Salaried') ? 'sal-card': ''">
      {{sallabel}} information
    </h5>
    <div class="card-body">
      <table id="tblsalariedinfo" class="table table-striped table-sm mb-1">
        <tbody class="field-4column-label">
          <!-- Employer Name Row - Styled like the original Client Type -->
          <tr>
            <td>
              <label for="employer">Employer Name</label>
            </td>
            <td>
              <span [ngClass]="updateEmployment ? 'badge-warning':'badge-success'" class="badge p-1 rounded">
                <app-branch-employers-search [searchValue]="employerNametxt | uppercase" [debounceTime]="300"
                  [frmControlName]="'employer'" [dontAdd]="true" require (empSelected)="doEmployerConfirm($event)"
                  (addnewRequired)="goforNew()">{{employerNametxt}}</app-branch-employers-search>
                <i class="text-emphasis">{{(updateEmployment)? 'new':'existing'}}</i>
                <div *ngIf="(this.employerDetailsModel?.id === 0) && Submitted">
                  <small class="text-danger">Employer selection is required.</small>
                </div>
              </span>
            </td>

            <td>
              <label for="employmentType">Employment Type</label>
            </td>
            <td>
              <mdb-select class="select table-control" [formControlName]="'employmentType'" (change)="toggleEmploymentType()"
                [ngClass]="{ 'is-invalid': Submitted && employmentType?.invalid }"
                required>
                <mdb-option *ngFor="let employmentTypeOption of employmentTypes" [value]="employmentTypeOption.value">
                  {{employmentTypeOption.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="employmentType?.invalid && Submitted">
                <div *ngIf="employmentType?.errors?.required">
                  <small class="text-danger">Employment type required.</small>
                </div>
                <div *ngIf="preauthModel!.employmentType === 'Unemployed'">
                  <small class="text-danger">Can't proceed with application.</small>
                </div>
              </div>
            </td>
          </tr>

          <!-- EMPLOYMENT -->
          <tr *ngIf="(!employmentType || employmentType!.value === null) || employmentType?.value === 'Permanent'">
            <td>
              <label>Employment Start Date</label>
            </td>
            <td *ngIf="(!employmentType || employmentType!.value == null) || employmentType?.value === 'Permanent'">
              <div class="input-group" [ngClass]="{ 'is-invalid': Submitted && employmentStartDate?.enabled && employmentStartDate?.invalid }">
                <input class="form-control lms-datepicker" [mdbDatepicker]="picker"  placeholder="YYYY-MM-DD"
                  (click)="picker.open()" [max]="maxDate"
                  formControlName="employmentStartDate"
                  (dateChange)="PayDateSelected($event)"
                  [ngClass]="{ 'is-invalid': Submitted && employmentStartDate?.enabled && employmentStartDate?.invalid }"
                  [required]="employmentType?.value === 'Permanent'" />
                  <mdb-datepicker-toggle [mdbDatepicker]="picker" icon="fas fa-calendar-alt" color="primary"></mdb-datepicker-toggle>
                  <mdb-datepicker #picker [confirmDateOnSelect]="true" [format]="'yyyy-mm-dd'" [maxDate]="maxDate"></mdb-datepicker>
              </div>
              <div *ngIf="employmentStartDate?.invalid || invalidDate">
                <div *ngIf="employmentStartDate?.errors?.required">
                  <small class="text-danger">Employment start date is required
                  </small>
                </div>
                <div *ngIf="invalidDate">
                  <small class="text-danger">{{payDateError}}</small>
                </div>
              </div>
            </td>
          </tr>

          <!-- CONTRACT START DATE and END DATE -->
          <tr *ngIf="showContractOrTemporary">
            <td>
              <label>Contract Start Date</label>
            </td>
            <td>
              <div class="input-group" [ngClass]="{ 'is-invalid': Submitted && contractStartDate?.enabled && contractStartDate?.invalid }">
                <input class="form-control lms-datepicker" [mdbDatepicker]="picker1" [max]="maxDate"
                  (click)="picker1.open()"
                  placeholder="YYYY-MM-DD" formControlName="contractStartDate"
                  [required]="showContractOrTemporary"
                  [ngClass]="{ 'is-invalid': Submitted && contractStartDate?.enabled && contractStartDate?.invalid }"
                  (dateChange)="PayDateSelected($event)" />
                <div class="input-group-text border-0">
                  <mdb-datepicker-toggle [mdbDatepicker]="picker1"></mdb-datepicker-toggle>
                  <mdb-datepicker #picker1 [confirmDateOnSelect]="true" [format]="'yyyy-mm-dd'" [maxDate]="maxDate"></mdb-datepicker>
                </div>
              </div>
              <div *ngIf="contractStartDate?.invalid  || invalidDate">
                <div *ngIf="contractStartDate?.errors?.required && Submitted">
                  <small class="text-danger">Contract start date is required</small>
                </div>
                <div *ngIf="invalidDate">
                  <small class="text-danger">{{payDateError}}</small>
                </div>
              </div>
            </td>
            <td>
              <label>Contract End Date</label>
            </td>
            <td>
              <div class="input-group" [ngClass]="{ 'is-invalid': Submitted && contractEndDate?.enabled && contractEndDate?.invalid }">
                <input class="form-control lms-datepicker" [mdbDatepicker]="picker2"  placeholder="YYYY-MM-DD"
                  (click)="picker2.open()" formControlName="contractEndDate"
                  [required]="showContractOrTemporary"
                  [ngClass]="{ 'is-invalid': Submitted && contractEndDate?.enabled && contractEndDate?.invalid }"
                  (dateChange)="PayEndDateSelected($event)" />
                <div class="input-group-text border-0">
                  <mdb-datepicker-toggle [mdbDatepicker]="picker2"></mdb-datepicker-toggle>
                  <mdb-datepicker #picker2 [confirmDateOnSelect]="true" [format]="'yyyy-mm-dd'"></mdb-datepicker>
                </div>
              </div>
              <div *ngIf="contractEndDate?.invalid">
                <div *ngIf="contractEndDate?.errors?.required && Submitted">
                  <small class="text-danger">Contract end date is required</small>
                </div>
              </div>
              <div *ngIf="invalidEndDate">
                <small class="text-danger">{{payDateError}}</small>
              </div>
            </td>
          </tr>

          <!-- WAGE FREQUENCY -->
          <tr>
            <td>
              <label>Wage Frequency</label>
            </td>
            <td>
              <mdb-select class="select table-control" formControlName="wageFrequency" (change)="togglewageFrequency()" required>
                <mdb-option *ngFor="let wageFrequencyOption of wageFrequencies" [value]="wageFrequencyOption.value">
                  {{wageFrequencyOption.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="f.wageFrequency?.invalid && Submitted">
                <div *ngIf="f.wageFrequency?.errors?.required">
                  <small class="text-danger">Wage frequency is required.</small>
                </div>
              </div>
            </td>
            <!-- PAY DAYs -->
            <td>
              <label>Pay Day</label>
            </td>
            <td>
              <div>
                <mdb-select class="select table-control" formControlName="payDate" style="width: 130px;" required>
                  <mdb-option *ngFor="let payDateOption of payDateOptions" [value]="payDateOption.value">
                    {{payDateOption.description}}
                  </mdb-option>
                </mdb-select>
              </div>

              <div *ngIf="f.payDate?.invalid && Submitted">
                <div *ngIf="f.payDate?.errors?.required">
                  <small class="text-danger">Salary pay date is required</small>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <label>Do you work on Saturdays?</label>
            </td>
            <td>
              <mdb-select class="select table-control" formControlName="workSaturday" required aria-role="combobox" aria-setsize="2" aria-disabled="false" aria-placeholder="Yes / No *">
                <mdb-option [value]="true">Yes</mdb-option>
                <mdb-option [value]="false">No</mdb-option>
              </mdb-select>
            </td>
          </tr>

          <!-- Industry Type -->
          <tr>
            <td>
              <label for="industryType">Employment Industry Type</label>
            </td>
            <td>
              <mdb-select class="select table-control" formControlName="industryType" aria-required aria-role="combobox" aria-disabled="false" placeholder="Select industry type *" required>
                <mdb-option *ngFor="let industryTypeOption of industryTypes" [value]="industryTypeOption.value">
                  {{industryTypeOption.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="f.industryType?.invalid && Submitted">
                <div *ngIf="f.industryType?.errors?.required">
                  <small class="text-danger">Industry type is required.</small>
                </div>
              </div>
            </td>
            <td *ngIf="f.industryType?.value === 'Other'">
              <label for="industryTypeOther">Industry type - Other</label>
            </td>
            <td *ngIf="f.industryType?.value === 'Other'">
              <div>
                <input type="text" class="form-control" formControlName="industryTypeOther" placeholder="Industry Type *" lmsNoSpecials
                  [value]="preauthModel!.industryTypeOther" [required]="f.industryType.value === 'Other'" />
              </div>
              <div *ngIf="f.industryType?.invalid && Submitted">
                <div *ngIf="f.industryType?.errors?.required">
                  <small class="text-danger">Other industry type is required.</small>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <label for="additionalIncome">Additional Income</label>
            </td>
            <td>
              <mdb-select class="select table-control" formControlName="additionalIncome" aria-required aria-role="combobox"
                aria-disabled="false" placeholder="Additional info" >
                <mdb-option *ngFor="let addIncome of lstAdditionalIncome"
                 [value]="addIncome.value">
                  {{addIncome.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="f.additionalIncome?.invalid">
                <div *ngIf="f.additionalIncome?.errors?.required && Submitted">
                  <small class="text-danger">Additional Income is required.</small>
                </div>
              </div>
            </td>
            <td *ngIf="isAIOtherOptionSelected">
              <label for="additionalIncomeOther">Additional Income Other</label>
            </td>
            <td *ngIf="isAIOtherOptionSelected">
              <input type="text"  class="form-control" formControlName="additionalIncomeOther" placeholder="Other Additional Income *" lmsNoSpecials
                [required]="isAIOtherOptionSelected" />
            </td>
          </tr>

          <!-- MONTHLY INCOME SECTION - ORIGINAL DESIGN -->
          <tr *ngIf="isMonthlyClient">
            <td>Last 3 monthly incomes</td>
            <td colspan="4" class="my-2">
              <ng-container formGroupName="payslips">
                <span class="input-group d-flex align-items-center ms-auto">
                  <button class="btn btn-secondary me-5" (click)="openPaySlip(1)" mdbRipple>
                    {{(income1 === 0) ? 'Income 1' : income1|zaRcurrency}}
                  </button>
                  <input hidden="true" [class.ng-invalid]="payslips!.hasError('duplicatePayslip')"
                    formControlName="payslip1" />

                  <button class="btn btn-secondary me-5" (click)="openPaySlip(2)" mdbRipple>
                    {{(income2 === 0) ? 'Income 2' : income2|zaRcurrency}}
                  </button>
                  <input hidden="true" [class.ng-invalid]="payslips!.hasError('duplicatePayslip')"
                    formControlName="payslip2" />

                  <input hidden="true" [class.ng-invalid]="payslips!.hasError('duplicatePayslip')"
                    formControlName="payslip3" />
                  <button class="btn btn-secondary me-5" (click)="openPaySlip(3)" mdbRipple>
                    {{(income3 === 0) ? 'Income 3' : income3|zaRcurrency}}
                  </button>
                </span>
                <div *ngIf="payslips?.invalid">
                  <div *ngIf="payslips!.hasError('duplicatePayslip')">
                    <small class="text-danger">
                      Duplicate payslip detected, this is not permitted!
                    </small>
                  </div>
                </div>
              </ng-container>
            </td>
          </tr>

          <!-- WEEKLY INCOME SECTION - PRIMARY COLORS (to match Listing Questions) -->
          <tr *ngIf="isWeeklyClient">
            <td colspan="4">
              <div class="card mb-2">
                <div class="card-header text-center">
                  <h5>Weekly Income Details (Last 3 Months)</h5>
                </div>
                <div class="card-body p-3">
                  <div class="row">
                    <!-- Month 1 -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 border-primary">
                        <div class="card-header text-center">
                          <strong>Month 1</strong>
                          <i *ngIf="isMonth1WeeklyComplete" class="fas fa-check-circle ms-2" style="color: #28a745; font-size: 1.1rem;"></i>
                        </div>
                        <div class="card-body p-2">
                          <div class="d-grid gap-2">
                            <button class="btn btn-primary w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(1, 1)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 1</small><br>
                              <strong>{{(weeklyIncomes[0] === 0) ? 'R 0.00' : (weeklyIncomes[0] | zaRcurrency)}}</strong>
                            </button>
                            <button class="btn btn-primary w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(1, 2)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 2</small><br>
                              <strong>{{(weeklyIncomes[1] === 0) ? 'R 0.00' : (weeklyIncomes[1] | zaRcurrency)}}</strong>
                            </button>
                            <button class="btn btn-primary w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(1, 3)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 3</small><br>
                              <strong>{{(weeklyIncomes[2] === 0) ? 'R 0.00' : (weeklyIncomes[2] | zaRcurrency)}}</strong>
                            </button>
                            <button class="btn btn-primary w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(1, 4)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 4</small><br>
                              <strong>{{(weeklyIncomes[3] === 0) ? 'R 0.00' : (weeklyIncomes[3] | zaRcurrency)}}</strong>
                            </button>
                          </div>
                        </div>
                        <div class="card-footer text-center" style="background-color: #e8eaf6; font-weight: bold;">
                          Total Month 1: {{getWeeklyMonthTotal(1) | zaRcurrency}}
                        </div>
                      </div>
                    </div>

                    <!-- Month 2 -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 border-primary">
                        <div class="card-header" style="background-color: #3f51b5; color: white; text-align: center; padding: 0.5rem;">
                          <strong>Month 2</strong>
                          <i *ngIf="isMonth2WeeklyComplete" class="fas fa-check-circle ms-2" style="color: #28a745; font-size: 1.1rem;"></i>
                        </div>
                        <div class="card-body p-2">
                          <div class="d-grid gap-2">
                            <button class="btn w-100 weekly-income-btn"
                                   style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(2, 1)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 1</small><br>
                              <strong>{{(weeklyIncomes[4] === 0) ? 'R 0.00' : weeklyIncomes[4] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(2, 2)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 2</small><br>
                              <strong>{{(weeklyIncomes[5] === 0) ? 'R 0.00' : weeklyIncomes[5] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(2, 3)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 3</small><br>
                              <strong>{{(weeklyIncomes[6] === 0) ? 'R 0.00' : weeklyIncomes[6] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(2, 4)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 4</small><br>
                              <strong>{{(weeklyIncomes[7] === 0) ? 'R 0.00' : weeklyIncomes[7] | zaRcurrency}}</strong>
                            </button>
                          </div>
                        </div>
                        <div class="card-footer text-center" style="background-color: #e8eaf6; font-weight: bold;">
                          Total Month 2: {{getWeeklyMonthTotal(2) | zaRcurrency}}
                        </div>
                      </div>
                    </div>

                    <!-- Month 3 -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 border-primary">
                        <div class="card-header" style="background-color: #3f51b5; color: white; text-align: center; padding: 0.5rem;">
                          <strong>Month 3</strong>
                          <i *ngIf="isMonth3WeeklyComplete" class="fas fa-check-circle ms-2" style="color: #28a745; font-size: 1.1rem;"></i>
                        </div>
                        <div class="card-body p-2">
                          <div class="d-grid gap-2">
                            <button class="btn w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(3, 1)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 1</small><br>
                              <strong>{{(weeklyIncomes[8] === 0) ? 'R 0.00' : weeklyIncomes[8] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(3, 2)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 2</small><br>
                              <strong>{{(weeklyIncomes[9] === 0) ? 'R 0.00' : weeklyIncomes[9] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(3, 3)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 3</small><br>
                              <strong>{{(weeklyIncomes[10] === 0) ? 'R 0.00' : weeklyIncomes[10] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 weekly-income-btn"
                                    style="border: 2px #3f51b5; background-color: transparent;"
                                    (click)="openWeeklyPaySlip(3, 4)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Week 4</small><br>
                              <strong>{{(weeklyIncomes[11] === 0) ? 'R 0.00' : weeklyIncomes[11] | zaRcurrency}}</strong>
                            </button>
                          </div>
                        </div>
                        <div class="card-footer text-center" style="background-color: #e8eaf6; font-weight: bold;">
                          Total Month 3: {{getWeeklyMonthTotal(3) | zaRcurrency}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Weekly Total -->
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="alert" class="card-header  text-white">
                        <div class="d-flex justify-content-between align-items-center">
                          <span><strong>Total Weekly Income (3 months):</strong></span>
                          <span class="fs-5"><strong>{{totalIncome | zaRcurrency}}</strong></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <!-- FORTNIGHTLY INCOME SECTION - PRIMARY COLORS (to match Listing Questions) -->
          <tr *ngIf="isFortnightlyClient">
            <td colspan="4">
              <div class="card mb-2">
                <div class="card-header" style="background-color: #3f51b5; color: white;">
                  <h6 class="mb-0">Fortnightly Income Details (Last 3 Months)</h6>
                </div>
                <div class="card-body p-3">
                  <div class="row">
                    <!-- Month 1 -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 border-primary">
                        <div class="card-header" style="background-color: #3f51b5; color: white; text-align: center; padding: 0.5rem;">
                          <strong>Month 1</strong>
                          <i *ngIf="isMonth1FortnightlyComplete" class="fas fa-check-circle ms-2" style="color: #28a745; font-size: 1.1rem;"></i>
                        </div>
                        <div class="card-body p-2">
                          <div class="d-grid gap-2">
                            <button class="btn w-100 fortnight-income-btn"
                                    style="color: #3f51b5; border-color: #3f51b5; border-width: 2px; background-color: transparent;"
                                    (click)="openFortnightlyPaySlip(1, 1)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Fortnight 1</small><br>
                              <strong>{{(fortnightlyIncomes[0] === 0) ? 'R 0.00' : fortnightlyIncomes[0] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 fortnight-income-btn"
                                    style="color: #3f51b5; border-color: #3f51b5; border-width: 2px; background-color: transparent;"
                                    (click)="openFortnightlyPaySlip(1, 2)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Fortnight 2</small><br>
                              <strong>{{(fortnightlyIncomes[1] === 0) ? 'R 0.00' : fortnightlyIncomes[1] | zaRcurrency}}</strong>
                            </button>
                          </div>
                        </div>
                        <div class="card-footer text-center" style="background-color: #e8eaf6; font-weight: bold;">
                          Total Month 1: {{getFortnightlyMonthTotal(1) | zaRcurrency}}
                        </div>
                      </div>
                    </div>

                    <!-- Month 2 -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 border-primary">
                        <div class="card-header" style="background-color: #3f51b5; color: white; text-align: center; padding: 0.5rem;">
                          <strong>Month 2</strong>
                          <i *ngIf="isMonth2FortnightlyComplete" class="fas fa-check-circle ms-2" style="color: #28a745; font-size: 1.1rem;"></i>
                        </div>
                        <div class="card-body p-2">
                          <div class="d-grid gap-2">
                            <button class="btn w-100 fortnight-income-btn"
                                    style="color: #3f51b5; border-color: #3f51b5; border-width: 2px; background-color: transparent;"
                                    (click)="openFortnightlyPaySlip(2, 1)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Fortnight 1</small><br>
                              <strong>{{(fortnightlyIncomes[2] === 0) ? 'R 0.00' : fortnightlyIncomes[2] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 fortnight-income-btn"
                                    style="color: #3f51b5; border-color: #3f51b5; border-width: 2px; background-color: transparent;"
                                    (click)="openFortnightlyPaySlip(2, 2)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Fortnight 2</small><br>
                              <strong>{{(fortnightlyIncomes[3] === 0) ? 'R 0.00' : fortnightlyIncomes[3] | zaRcurrency}}</strong>
                            </button>
                          </div>
                        </div>
                        <div class="card-footer text-center" style="background-color: #e8eaf6; font-weight: bold;">
                          Total Month 2: {{getFortnightlyMonthTotal(2) | zaRcurrency}}
                        </div>
                      </div>
                    </div>

                    <!-- Month 3 -->
                    <div class="col-md-4 mb-3">
                      <div class="card h-100 border-primary">
                        <div class="card-header" style="background-color: #3f51b5; color: white; text-align: center; padding: 0.5rem;">
                          <strong>Month 3</strong>
                          <i *ngIf="isMonth3FortnightlyComplete" class="fas fa-check-circle ms-2" style="color: #28a745; font-size: 1.1rem;"></i>
                        </div>
                        <div class="card-body p-2">
                          <div class="d-grid gap-2">
                            <button class="btn w-100 fortnight-income-btn"
                                    style="color: #3f51b5; border-color: #3f51b5; border-width: 2px; background-color: transparent;"
                                    (click)="openFortnightlyPaySlip(3, 1)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Fortnight 1</small><br>
                              <strong>{{(fortnightlyIncomes[4] === 0) ? 'R 0.00' : fortnightlyIncomes[4] | zaRcurrency}}</strong>
                            </button>
                            <button class="btn w-100 fortnight-income-btn"
                                    style="color: #3f51b5; border-color: #3f51b5; border-width: 2px; background-color: transparent;"
                                    (click)="openFortnightlyPaySlip(3, 2)"
                                    mdbRipple
                                    onmouseover="this.style.backgroundColor='#3f51b5'; this.style.color='white';"
                                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#3f51b5';">
                              <small>Fortnight 2</small><br>
                              <strong>{{(fortnightlyIncomes[5] === 0) ? 'R 0.00' : fortnightlyIncomes[5] | zaRcurrency}}</strong>
                            </button>
                          </div>
                        </div>
                        <div class="card-footer text-center" style="background-color: #e8eaf6; font-weight: bold;">
                          Total Month 3: {{getFortnightlyMonthTotal(3) | zaRcurrency}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Fortnightly Total -->
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="alert" style="background-color: #3f51b5; color: white; border-radius: 8px;">
                        <div class="d-flex justify-content-between align-items-center">
                          <span><strong>Total Fortnightly Income (3 months):</strong></span>
                          <span class="fs-5"><strong>{{totalIncome | zaRcurrency}}</strong></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <!-- SIMPLIFIED VALIDATION MESSAGE -->
          <tr *ngIf="shouldShowValidationError()">
            <td></td>
            <td colspan="3">
              <small class="text-danger">
                All income fields need to be captured for the selected wage frequency.
              </small>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<!-- Payslip template remains the same -->
<ng-template #payslipTemplate let-payslipMdl>
  <div mdbDropdownMenu class="dropdown-menu dropdown-menu-end dropdown-menu-lg-start" style="display: block;">
    <form>
      <table class="table table-striped table-sm shadow-1-strong rounded-1 p-1">
        <tbody class="field-4column-label">
          <tr>
            <td style="width: 8%">Pay Date:</td>
            <td>
              <div class="input-group">
                <input class="form-control" [mdbDatepicker]="picker" [max]="maxDate" placeholder="YYYY-MM-DD" required>
                <!-- (dateChange)="onPayslipDateSelect($event)" -->
                <span class="input-group-text  border-0">
                  <mdb-datepicker-toggle [mdbDatepicker]="picker"></mdb-datepicker-toggle>
                  <mdb-datepicker #picker></mdb-datepicker>
                </span>
              </div>
              <div *ngIf="invalidDate">
                <small class="text-danger">{{payDateError}}</small>
              </div>
            </td>
          </tr>
          <tr>
            <td style="width: 8%">Nett Income:</td>
            <td>
              <div class="input-group">
                <span class="input-group-text">R</span>
                <input class="form-control" placeholder="NETT Income" lmsNumbersOnly [allowDecimals]="true" min="0">
              </div>
            </td>
          </tr>
          <tr>
            <td style="width: 8%">Other Income:</td>
            <td>
              <input class="form-control" lmsNumbersOnly [allowDecimals]="true" min="0" placeholder="Other Income"
                noSpecial>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="center-screen mt-3 mb-1">
        <button class="btn btn-primary btn-sm" type="button" color="primary"
          [disabled]="invalidDate">
          Save
        </button>
      </div>
    </form>
  </div>
</ng-template>
